module.exports = __webpack_public_path__ + "static/media/permission.70d0f019.svg";